<div class="block">
  <div
    class="no-padding-right-left w-100pc mt-1"
    style="display: flex; justify-content: space-between; align-items: center"
  >
    <div class="color-black w-40pc">
      <div class="input-group bottom--8px">
        <input
          type="text"
          class="form-control searchField padding-right-20"
          required=""
          #searchField
          [ngClass]="{ 'has-value': searchField.value }"
          name="searchText"
          [(ngModel)]="searchText"
        />
        <label for="searchText">{{
          "label_search_criterion" | translate
        }}</label>
        <span class="icons"
          ><a><i class="fas fa-search" aria-hidden="true"></i></a
        ></span>
      </div>
    </div>
  </div>
</div>
<div class="block overflow-auto heightCalc-10 scrollbar-visible">
  <ul class="bulkList">
    <li
      class="f-14 border-bottom padding-bottom-10"
      [ngClass]="{ active: item == formControl.value }"
      (click)="fnSetDateFormat(item.value)"
      *ngFor="
        let item of dateFormats | grdFilter : { value: searchText } : false
      "
    >
      <span class="d-inline-block">
        {{ item.value }}
      </span>
    </li>
  </ul>
</div>
